import setBuilder from './SetBuilder'
import presetSelect from './PresetSelect'
import metadataSlice from './MetadataSlice'
import search from './Search'
export default { presetSelect, setBuilder, metadataSlice, search }



// WEBPACK FOOTER //
// ./src/app/configuration/Template/config/components/selection/index.js